export default __webpack_public_path__ + "static/media/publish-icon.22872c67.svg";